// extracted by mini-css-extract-plugin
module.exports = {"container":"page-not-found_container__MyM4z","title":"page-not-found_title__7DjL9","subTitle":"page-not-found_subTitle__3lC4S","backButton":"page-not-found_backButton__3bTsw"};